import React from 'react';
import { ReactComponent as Fonts } from '../../assets/images/icons/fontsIcon.svg';

export default function FontsIcon({ className }) {
  return (
    <Fonts className={`icon ${className}`} />
  );
}
